import { Box, FormControl } from "@mui/material";
import { Control, Controller } from "react-hook-form";
import React, { FC } from "react";

import { CheckboxCustom } from "../../../styles/styledComponents";

interface ICheckboxControllerProps {
  id?: string;
  name: string;
  label: string;
  control: Control<any>;
  fullWidth?: boolean;
  defaultChecked?: boolean;
  disabled?: boolean;
}

const CheckboxController: FC<ICheckboxControllerProps> = ({
  id,
  name,
  label,
  control,
  fullWidth = true,
  defaultChecked = false,
  disabled = false,
}) => {
  const fieldId = id || name;

  return (
    <FormControl fullWidth={fullWidth}>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Controller
          name={name}
          control={control}
          defaultValue={defaultChecked}
          render={({ field, fieldState }) => (
            <>
              <CheckboxCustom
                id={fieldId}
                disabled={disabled}
                {...field}
                checked={field.value}
                color={!!fieldState.error ? "error" : "default"}
              />
              {label && (
                <label
                  className={`ml-2 text-sm ${field.value?"text-light-black":"text-gray-1"}`}

                >
                  {label}
                </label>
              )}
            </>
          )}
        />
      </Box>
    </FormControl>
  );
};

export default CheckboxController;
